import { defineMessages } from 'react-intl';

/**
 * Static trial-recap upgrade feature rows (Practice + Clinician end-of-trial modals).
 *
 * Figma: https://www.figma.com/design/MSqFiRMYvicVZlaiWjmFG3/Trials---upgrades?node-id=10266-38745
 */
export const upgradeTrialFeatureListMessages = defineMessages({
  everythingInCurrentPlanPlus: {
    defaultMessage: 'Everything in your current plan, plus:',
    id: 'wkTZaeUQcP',
    description:
      'Intro line above the trial-recap upgrade feature list when the user already has a paid plan',
  },
  featureAnswersInPatientSessions: {
    defaultMessage: 'Answers in patient sessions',
    id: '13rJQuIACx',
    description:
      'First row label on the trial-recap upgrade feature list (Evidence in sessions)',
  },
  featureMoreEvidenceInPatientSessionsTooltip: {
    defaultMessage:
      'Higher usage limits in patient sessions. Produce more clinical answers, summaries, handouts and care plans from Evidence.',
    id: 'aMSXa+BQzF',
    description:
      'Tooltip body for the info control beside “More Evidence in patient sessions” on the trial-recap upgrade feature list',
  },
  featureMoreEvidenceInPatientSessionsTooltipAria: {
    defaultMessage: 'More about Evidence in patient sessions',
    id: 'godxHUQYY8',
    description:
      'Accessible name for the info tooltip trigger beside "Evidence in patient sessions"',
  },
  featurePreferredSources: {
    defaultMessage: 'Set preferred sources',
    id: 'BjtyxmnMGe',
    description:
      'Second row label on the trial-recap upgrade feature list (stacked source avatars)',
  },
  featureBuildEvidenceLibrary: {
    defaultMessage: 'Build an Evidence library',
    id: '5uYPwRXfv7',
    description:
      'Third row label on the trial-recap upgrade feature list (save and organise evidence)',
  },
  featureBuildEvidenceLibraryTooltip: {
    defaultMessage: 'Save and organize evidence for future reference.',
    id: 'j/txsntKxF',
    description:
      'Tooltip body for the info control beside “Build an Evidence library” on the trial-recap upgrade feature list',
  },
  featureBuildEvidenceLibraryTooltipAria: {
    defaultMessage: 'More about building an Evidence library',
    id: 'pOTQ9EBYsL',
    description:
      'Accessible name for the info tooltip trigger beside "Build an Evidence library"',
  },
});
